var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntermediary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5654 13.4463C12.0185 13.4463 13.1963 12.268 13.1963 10.8155L14.1568 0.75H9.94803L7.93457 10.8155C7.93464 12.268 9.1124 13.4463 10.5654 13.4463Z",
    fill: "#F75586"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.4463C19.4525 13.4463 20.6302 12.268 20.6302 10.8155L20.1046 0.75H15.8953L15.3691 10.8155C15.3691 12.268 16.5469 13.4463 18 13.4463Z",
    fill: "#F75586"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4351 13.4464C26.8877 13.4464 28.0655 12.2681 28.0655 10.8156L26.0525 0.75H21.8438L22.8043 10.8155C22.8043 12.2681 23.9821 13.4464 25.4351 13.4464Z",
    fill: "#F75586"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 0.75H27.791L30.2389 10.8155C30.2389 12.0452 31.0859 13.0695 32.2264 13.3577V30.5314H28.2618V18.9112H18.261V30.5314H3.77414V13.3577C4.91403 13.0695 5.76162 12.0452 5.76162 10.8156L8.20896 0.750068H4.00014L0.5 10.8156C0.5 11.6829 0.925059 12.446 1.57311 12.9254V32.7326H34.4274V12.9254C35.0749 12.446 35.5 11.6829 35.5 10.8156L31.9999 0.75ZM26.6112 30.5314H19.9115V20.5623H26.6112V30.5314V30.5314Z",
    fill: "#F75586"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8285 18.1318H7.97852V23.9818H13.8285V18.1318Z",
    fill: "#F75586"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntermediary);
export default __webpack_public_path__ + "static/media/intermediary.706f9d9ac212211d0f805b6a94ff63fc.svg";
export { ForwardRef as ReactComponent };